import React from "react";
import { Tab } from "semantic-ui-react";
import Tubes from "features/FolderManager/components/Tubes";

const AliquotsContent = ({
	data,
	disabled,
	user,
	generalParameters,
	patchUntakenTube,
	getAllTubeUntakenReasons,
	submitAddTubeModal,
	openDeleteNotPrescribedTubeConfirm,
	patchMultipleTubes,
	loadAddTubeModalData,
	patchTubeSamplingTime,
	cancelReuseTube,
	getReusableTubes,
	getAllTubeNatureReasons,
	patchTubeNature,
	getMissingVolumeTubes,
	submitDeleteNotPrescribedTubeConfirm,
	tubeReducer,
	centerWithAliquots,
}) => {
	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			<Tubes
				key="aliquots"
				tubes={data.tubes.filter((t) => t.analyses && t.analyses.some((a) => a.properties.pretreatment_stability <= centerWithAliquots))}
				aliquot={true}
				take_number={data.take_number}
				patchUntakenTube={patchUntakenTube}
				getAllTubeUntakenReasons={getAllTubeUntakenReasons}
				submitAddTubeModal={submitAddTubeModal}
				openDeleteNotPrescribedTubeConfirm={openDeleteNotPrescribedTubeConfirm}
				patchMultipleTubes={patchMultipleTubes}
				user={user}
				loadAddTubeModalData={loadAddTubeModalData}
				patchTubeSamplingTime={patchTubeSamplingTime}
				disabled={disabled}
				tubeReducer={tubeReducer}
				cancelReuseTube={cancelReuseTube}
				getReusableTubes={getReusableTubes}
				getAllTubeNatureReasons={getAllTubeNatureReasons}
				patchTubeNature={patchTubeNature}
				getMissingVolumeTubes={getMissingVolumeTubes}
				submitDeleteNotPrescribedTubeConfirm={submitDeleteNotPrescribedTubeConfirm}
				isHome={data.isHome}
				safeplaceResult={data.prescriptions && data.prescriptions.length > 0 ? data.prescriptions[0].safeplace_result : null}
				urgencyPretreatementLimit={generalParameters.data.urgencyPretreatementLimit}
				isDeposit={data.deposit}
			/>
		</Tab.Pane>
	);
};
export default AliquotsContent;
